import {
  createMultipleItemResultNotificationValues,
  MultipleItemResultNotificationValues
} from '~commonInfra/contentActions/ActionMessages';
import { ContentActionNotification } from '~commonInfra/contentActions/ContentActionNotification';
import {
  IErrorItem, MultipleItemResult
} from '~commonInfra/contentActions/MultipleItemResult';
import { Set } from '~commonInfra/utils/Set';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Formatters, Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { FlowBaseInfo, FlowBasicInfo } from '../models/FlowInfo';
import { FlowErrors } from './FlowErrors';

export namespace RunFlowOnOutputStepsNotification {
  export function notify(
    result: IResult,
    flow: FlowBasicInfo,
    outputCount: number) {

    const flowName = L10n.elideIfLong(flow.name);

    let flowSet = Set.singletonForIdItem(flow);
    const notification: MultipleItemResultNotificationValues = createMultipleItemResultNotificationValues(
      new MultipleItemResult(flowSet, result),
      {
        describeSuccessSummary: () => {
          return Messages.runFlowsOnOutputStepsSuccess({ FLOW_NAME: flowName, ITEM_COUNT: outputCount, ITEM_COUNT_LOC: Formatters.formatCount(outputCount) });
        },
        describeErrorSummary: () => {
          return Messages.runFlowsOnOutputStepsError({ FLOW_NAME: flowName });
        },
        describeErrorDetail: (errorItem: IErrorItem<FlowBaseInfo>) => {
          const siteUrls = siteUrlsSelector(getAppStore().getState());
          const error = {
            flowName,
            errorCode: errorItem.error.code,
          };
          return {
            itemName: flowName,
            itemUrl: siteUrls.flowUrl(flow.id),
            errorMessage: FlowErrors.errorMessageFor(error, null),
          };
        }
      }
    );
    ContentActionNotification.displayItemizedToastsForResult(notification);
  }
}

export type RunFlowOnOutputStepsNotification = typeof RunFlowOnOutputStepsNotification;
